import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfigService } from 'app-config';


@Injectable({
	providedIn: 'root'
})
export class SpecimenPreviewService {

	selectedFile: File = null;
	API_URL = AppConfigService.settings.apiServer.apiUrl;
	constructor(private http: HttpClient) { }


	// Making service call
	getImages(kitNumber): Observable<any> {

		return this.http?.get(`${this.API_URL}/kit/${kitNumber}/viewImages`);
	}

	// Service Call for get S3 image url
	getImageS3Url(imageName): Observable<any> {
		return this.http?.get(`${this.API_URL}/fileUrl?fileName=${imageName}`, { "responseType": "text" });
	}
}

